import Button from 'components/button';
import { Select } from 'components/forms';
import { autobind } from 'core-decorators';
import { range } from 'core/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SelectedProducts from './selected-products';
import styles from './styles.css';

@autobind
export default class ProductPicker extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired, // these are actually products
        perItemLimit: PropTypes.number.isRequired,
        value: PropTypes.array, // these are the order's items
        toggleSelectedProduct: PropTypes.func,
    };

    state = {
        category: '',
        product: '',
        quantity: '',
    };

    getCategoryOptions() {
        return this.props.items
            .filter(product => product.stock > 0)
            .map(({category}) => ({value: category.id, label: category.name, order: category.order}))
            .filter((category, index, all) => (all.findIndex(({value}) => value === category.value) === index))
            .sort((a, b) => a.order - b.order);
    }

    getProductOptions() {
        const buildOptions = items => items.map(({id, name}) => ({value: id, label: name}));

        const currentlySelectedProductIds = this.props.value.map(({item}) => item);
        const availableProducts = this.props.items.filter(item =>
            !currentlySelectedProductIds.includes(item.id) && item.stock > 0);

        if (!this.state.category) return buildOptions(availableProducts);
        return buildOptions(availableProducts.filter(product => product.category.id === this.state.category));
    }

    getQuantityOptions(id) {
        const {perItemLimit, items} = this.props;
        const buildOptions = values => values.map(index => ({value: index + 1, label: String(index + 1)}));

        const defaultOptions = buildOptions(range(perItemLimit));

        const productId = id || this.state.product;
        if (!productId) return defaultOptions;

        const product = items.find(({id}) => id === productId);
        if (product && product.stock < perItemLimit) {
            const stockRange = range(product.stock);
            const existentItem = this.props.value.find(item => item.item === productId);
            if (existentItem && !stockRange.includes(existentItem.quantity)) {
                const compoundStock = existentItem.quantity + product.stock;
                if (perItemLimit < compoundStock) return defaultOptions;
                return buildOptions(range(compoundStock));
            }
            return buildOptions(stockRange);
        }

        return defaultOptions;
    }

    handleFieldChange(key) {
        return (value) => {
            if (key === 'product') return this.setState({product: value, quantity: ''});
            if (key === 'category') return this.setState({category: value, product: '', quantity: ''});
            this.setState({[key]: value}, () => {
                if (this.state.product && this.state.quantity) this.props.toggleSelectedProduct();
            });
        };
    }

    handleProductAdd() {
        const product = this.props.items.find(item => item.id === this.state.product);

        this.props.onChange([...this.props.value, {
            item: product.id,
            quantity: this.state.quantity,
        }]);

        this.setState({
            category: '',
            product: '',
            quantity: '',
        }, () => this.props.toggleSelectedProduct());
    }

    handleRemove(id) {
        return () => {
            this.props.onChange(this.props.value.filter(selectedProduct => selectedProduct.item !== id));
        };
    }

    handleUpdate(id) {
        return (newValue) => {
            const productToUpdate = this.props.value.find(item => item.item === id);
            const value = [...this.props.value];

            value.splice(value.indexOf(productToUpdate), 1, {...productToUpdate, quantity: newValue});
            this.props.onChange(value);
        };
    }

    renderProductSelection() {
        return (
            <div className={styles.productSelection}>
                <div className={styles.selectGroup}>
                    <div className={styles.select}>
                        <p className={styles.selectLabel}>Categoría</p>
                        <Select
                            options={this.getCategoryOptions()}
                            value={this.state.category}
                            onChange={this.handleFieldChange('category')}
                            clearable
                            onClear={this.props.toggleSelectedProduct}
                        />
                    </div>
                    <div className={styles.select}>
                        <p className={styles.selectLabel}>Producto</p>
                        <Select
                            options={this.getProductOptions()}
                            value={this.state.product}
                            onChange={this.handleFieldChange('product')}
                        />
                    </div>
                    <div className={styles.select}>
                        <p className={styles.selectLabel}>Cantidad</p>
                        <Select
                            options={this.getQuantityOptions()}
                            value={this.state.quantity}
                            onChange={this.handleFieldChange('quantity')}
                        />
                    </div>
                </div>
                <Button
                    type='button'
                    theme='yellow'
                    disabled={!this.state.product || !this.state.quantity}
                    onClick={this.handleProductAdd}>
                    AGREGAR
                </Button>
            </div>
        );
    }

    renderSelectedProducts() {
        const selectedProducts = this.props.value.map(item => {
            const product = this.props.items.find(product => product.id === item.item);
            return {
                ...item,
                category: product.category,
                name: product.name,
            };
        });
        return (
            <SelectedProducts
                items={selectedProducts}
                perItemLimit={this.props.perItemLimit}
                onUpdate={this.handleUpdate}
                onRemove={this.handleRemove}
                getQuantityOptions={this.getQuantityOptions}
            />
        );
    }

    render() {
        return (
            <div className={styles.root}>
                {this.renderProductSelection()}
                {this.props.value.length > 0 && this.renderSelectedProducts()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/product-picker/index.js